const API_BASE_URL = "https://dpsjodhpur.in/backend";

export default API_BASE_URL;